import { Component, EventEmitter, inject, Output } from '@angular/core';
import { LocationAdminStore } from '../location.admin.store.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { InfosGuidanceComponent } from '../../../components/infos-guidance/infos-guidance.component';
import { TitleCasePipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { HumanizePipe } from '../../../pipes/humanize.pipe';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { JobNotificationsSubscribeComponent } from './job-notifications-subscribe.component';
import { wideModalConfig } from '../../../consts/mdc/mdc-modal-config.const';
import { MdcListChipsComponent } from '../../../components/mdc/mdc-chips/mdc-list-chips.component';
import { MatMenuModule } from '@angular/material/menu';
import { ConfirmDialogComponent, DialogData } from '../../../components/mdc/mdc-dialog/confirm-dialog.component';
import { smallModalConfig } from '../../../consts/modal-config.const';
import { RepairerJobSubscription } from '../../../model/user.model';
import { RepairerAdminService } from '../../../services/repairer-admin.service';
import { MessagingService } from '../../../components/messaging/messaging.service';
import { catchError, filter, switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'job-notifications',
  templateUrl: './job-notifications.component.html',
  imports: [
    MatDividerModule,
    MatButtonModule,
    InfosGuidanceComponent,
    MatIconModule,
    MatCardModule,
    HumanizePipe,
    TitleCasePipe,
    MatDialogModule,
    MdcListChipsComponent,
    MatMenuModule
  ]
})
export class JobNotificationsComponent {
  @Output() refreshRepairerSite = new EventEmitter<void>();
  locationAdminStore = inject(LocationAdminStore);
  #matDialog = inject(MatDialog);
  #repairerAdminService = inject(RepairerAdminService);
  #messagingService = inject(MessagingService);

  subscribeToEvents(): void {
    this.#matDialog
      .open(JobNotificationsSubscribeComponent, { ...wideModalConfig })
      .afterClosed()
      .subscribe((res) => res && this.refreshRepairerSite.emit());
  }

  unsubscribeEvents(): void {
    const data: DialogData = {
      title: 'Unsubscribe',
      message: 'Unsubscribe to job event notifications.',
      confirmButton: 'UNSUBSCRIBE'
    };

    this.#matDialog
      .open(ConfirmDialogComponent, { ...smallModalConfig, width: '355px', data, panelClass: 'auto-width-buttons' })
      .afterClosed()
      .pipe(
        filter((res) => res === 'UNSUBSCRIBE'),
        switchMap(() => {
          const subscription: RepairerJobSubscription = {
            emailSubscriptionEvents: [],
            emailSubscriptionRecipients: []
          };
          return this.#repairerAdminService
            .updateEmailSubscription(this.locationAdminStore.userRepairerSite().id, subscription)
            .pipe(
              tap(() => this.#messagingService.confirm('Unsubscribed from Job Notifications.')),
              catchError((error) => {
                this.#messagingService.error('Could not unsubscribe from Job Notifications.');
                throw error;
              })
            );
        })
      )
      .subscribe(() => this.refreshRepairerSite.emit());
  }
}
